<template>
<fieldset :id="name">
  <div class="radio-group">
    <template v-for="(item, index) in items">
      <input type="radio" :class="name + '-cls'" :id="name + '-' + index" :name="name" :key='name + "-inp-" + index' :checked="selectedValue ? selectedValue === values[index] : index === 0" @change="onChange($event)" :value="values? values[index]: item">
      <label class="filter-options-label" :id="name + '-lbl-' + index" :for="name + '-' + index" :key='name + "-lbl-" + index'>{{$t(item)}}</label>
      <div v-if="showSeperators && index < items.length - 1" class="ml-1 mr-1 vertical-line" :key='name + "-lin-" + index'></div>
    </template>
  </div>
</fieldset>
</template>

<script>
export default {
  components: {
  },
  props: {
    additionalData: String,
    name: String,
    items: Array,
    values: Array,
    selectedValue: String,
    showSeperators: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (event) {
      var value = event.target.value
      if (this.additionalData) {
        this.$emit('valueChanged', value, this.additionalData)
      } else {
        this.$emit('valueChanged', value)
      }
    }
  }
}
</script>

<style>
.filter-options-label {
  color: gray;
}
input[type="radio"]:checked+label {
  background-color: rgb(233, 232, 232);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/RadioButtonGroup.vue